import { RefObject } from "react";
import { MapStateToPropsFactory } from "react-redux";

import { BetslipStep } from "@ppb/tbd-store/state/betslip/Betslip.types";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { getBetslipPlaceStatus } from "../../store/state/betslip-module/betslip-module-selectors";
import { RequestStatus } from "../../store/state/betslip-module/betslip-module.types";

export type ContainerProps = {
  drawerRef?: RefObject<HTMLDivElement | null>;
};

export type StateProps = {
  step: BetslipStep;
  placeStatus: RequestStatus;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps | false, ContainerProps, BetslipApplicationState> =
  () => (state) => {
    const step = state.betslipModule?.isReceiptReusePending ? "REPORT" : state.betslipModule?.step;

    if (!step) {
      return false;
    }

    const placeStatus = getBetslipPlaceStatus(state) || "NONE";

    return {
      step,
      placeStatus,
    };
  };
